/** PRODUCT FEEDBACK — one feedback row with vote button. */
import { ChevronUp, MessageSquare, Paperclip, GitMerge, Map } from "lucide-react";
import { TypePill, StatusPill, Pill, PRIORITY_CLS, fmtD, short } from "./feedbackUtils";

export default function FeedbackCard({ f, staff, onOpen, onVote }) {
  const merged = f.status === "MERGED";
  return (
    <div className="os-card p-3 flex gap-3 items-start cursor-pointer" onClick={() => onOpen(f.id)} data-testid={`fb-card-${f.number}`}>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); if (!merged) onVote(f); }}
        disabled={merged}
        className={`shrink-0 w-12 h-14 rounded-xl border flex flex-col items-center justify-center transition-colors ${f.voted ? "bg-[color:var(--st-accent)] text-white border-transparent" : "bg-white border-[color:var(--st-border)] hover:border-[color:var(--st-accent)]"} disabled:opacity-40`}
        data-testid={`fb-vote-${f.number}`}
        aria-label="Vote"
      >
        <ChevronUp className="h-4 w-4" />
        <span className="text-[13px] font-bold leading-none" data-testid={`fb-votes-${f.number}`}>{f.vote_count}</span>
      </button>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-1.5">
          <span className="font-mono text-[11px] text-[color:var(--st-text-muted)]">{f.number}</span>
          <TypePill type={f.type} />
          <StatusPill status={f.status} testId={`fb-status-${f.number}`} />
          <Pill cls={PRIORITY_CLS[f.priority]}>{f.priority}</Pill>
          {f.roadmap_item_id && <Pill cls="bg-[#EEE9FF] text-[#5B3FD6]"><Map className="h-3 w-3 mr-1" /> Roadmap</Pill>}
          {merged && <Pill cls="bg-[color:var(--st-surface-alt)]"><GitMerge className="h-3 w-3 mr-1" /> → {f.merged_into_number}</Pill>}
        </div>
        <div className="mt-1 text-[14px] font-semibold text-[color:var(--st-text)] truncate">{f.title}</div>
        {f.description && <div className="text-[12px] text-[color:var(--st-text-muted)] line-clamp-2 mt-0.5">{f.description}</div>}
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-[color:var(--st-text-muted)]">
          <span>{f.module}</span>
          <span>· {f.customer_name || (f.is_staff_submission ? "Suntronix" : "Customer")}</span>
          <span>· {short(f.submitted_by)} · {fmtD(f.created_at)}</span>
          {staff && f.assignee && <span>· Owner {short(f.assignee)}</span>}
          <span className="inline-flex items-center gap-1"><MessageSquare className="h-3 w-3" /> {f.comment_count}</span>
          {f.attachments?.length > 0 && <span className="inline-flex items-center gap-1"><Paperclip className="h-3 w-3" /> {f.attachments.length}</span>}
        </div>
      </div>
    </div>
  );
}
